import { cn, getUserCoinCount } from '@/lib/utils';
import { LucideProps } from 'lucide-react';
import IconCoins from './IconCoins';

type TProps = {
  className?: string;
  diamondWallet?: {
    coins?: number;
  };
  coins?: number;
  iconCoins?: LucideProps & {
    className?: string;
  };
};

const LabelCoins = ({ coins = 0, diamondWallet, className, iconCoins }: TProps) => (
  <div className={cn(
    'flex items-center space-x-1 text-sm',
    className
  )}>
    <span>
      {
        Intl
          .NumberFormat(
            'fr-FR',
            {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }
          ).format(getUserCoinCount(coins, diamondWallet?.coins))
      }
    </span>
    <IconCoins {...iconCoins} />
  </div>
);

export default LabelCoins;
